// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"ad405325","887":"68046948"}[chunkId] + ".chunk.css";
};